import * as ThunkAuthorized from './authorization';
import * as ThunkComponent from './component';
import * as ThunkBonusPersonalIssue from './bonus-personal-issue';
import * as ThunkBonuses from './bonuses';
import * as ThunkCashiersShift from './cashiersShift';
import * as ThunkCashiersUsers from './cashiersUsers';
import * as ThunksCredit from './credit';
import * as ThunkExchangeRates from './exchangeRates'
import * as ThunkFreespin from './freespin';
import * as ThunkFreespinGame from './freespinGame';
import * as ThunkGamerReport from './gamer-report';
import * as ThunkHistoryCredit from './history-credit';
import * as ThunkInformationPanel from './information_panel';
import * as ThunkJackpot from './jackpot';
import * as ThunkKyc from './kyc';
import * as ThunkLottery from './lottery';
import * as ThunkMessager from './messager';
import * as ThunkOrganization from './organization';
import * as ThunkPaymentSystem from './paymentSystem';
import * as ThunkPresentConfirmation from './presentConfirmation';
import * as ThunkQiwi from './qiwi';
import * as ThunkReferrals from './referrals';
import * as ThunkReplenishment from './replenishment';
import * as ThunkReportBalance from './report-balance';
import * as ThunkReportBonuses from './report-bonuses';
import * as ThunkReportDaily from './report-daily';
import * as ThunkReportEvent from './report-event';
import * as ThunkReportFinance from './report-finance';
import * as ThunkReportGroup from './report-group';
import * as ThunkReportJackpot from './report-jackpot';
import * as ThunkReportProvider from './report-provider';
import * as ThunkReportUnconfirmed from './report-unconfirmed';
import * as ThunkSearchUser from './search-user';
import * as ThunkSupport from './support';
import * as ThunkTournament from './tournament';
import * as ThunkUsers from './users';
import * as ThunkWithdrawals from './withdrawals';
import * as ThunkUserProfile from './user-profile'
import * as ThunkCashiersMobile from './cashiersMobile';
import * as ThunkCreditMobile from './creditMobile';
import * as ThunkGamerMobile from './gamerMobile';
import * as ThunkGamesMobile from './gamesMobile';
import * as ThunkInformationPanelMobile from './informationPanelMobile';
import * as ThunkJackpotMobile from './jackpotMobile';
import * as ThunkKycMobile from './kycMobile';
import * as ThunkPaymentMobile from './paymentMobile';
import * as ThunkReplenishmentMobile from './replenishmentMobile';
import * as ThunkReportMobile from './reportMobile';
import * as ThunkSecurityMobile from './securityMobile';
import * as ThunkSupportMobile from './supportMobile';
import * as ThunkWithdrawalsMobile from './withdrawalsMobile';


export const Thunk = {
    Authorized: ThunkAuthorized,
    Component: ThunkComponent,
    BonusPersonal: ThunkBonusPersonalIssue,
    Bonuses: ThunkBonuses,
    CashiersShift: ThunkCashiersShift,
    CasiersUsers: ThunkCashiersUsers,
    Credit: ThunksCredit,
    ExchangeRates: ThunkExchangeRates,
    Freespin: ThunkFreespin,
    FreespinGame: ThunkFreespinGame,
    GameReport: ThunkGamerReport,
    HistoryCredit: ThunkHistoryCredit,
    InformationPanel: ThunkInformationPanel,
    Jackpot: ThunkJackpot,
    Kyc: ThunkKyc,
    Lottery: ThunkLottery,
    Messanger: ThunkMessager,
    Organization: ThunkOrganization,
    Payment: ThunkPaymentSystem,
    PeresentConfirmation: ThunkPresentConfirmation,
    Qiwi: ThunkQiwi,
    Referrals: ThunkReferrals,
    Replenishment: ThunkReplenishment,
    ReportBalance: ThunkReportBalance,
    ReportBonuses: ThunkReportBonuses,
    ReportDaily: ThunkReportDaily,
    ReportEvent: ThunkReportEvent,
    ReportFinance: ThunkReportFinance,
    ReportGroup: ThunkReportGroup,
    ReportJackpot: ThunkReportJackpot,
    ReportProvider: ThunkReportProvider,
    ReportUnconfirmed: ThunkReportUnconfirmed,
    SearchUser: ThunkSearchUser,
    Support: ThunkSupport,
    Tournament: ThunkTournament,
    Users: ThunkUsers,
    Withdrawals: ThunkWithdrawals,
    Profile: ThunkUserProfile,
    CasiersMobile: ThunkCashiersMobile,
    CreditMobile: ThunkCreditMobile,
    GamerMobile: ThunkGamerMobile,
    GamesMobile: ThunkGamesMobile,
    InformationPanelMobile: ThunkInformationPanelMobile,
    JackpotMobile: ThunkJackpotMobile,
    KycMobile: ThunkKycMobile,
    PaymentMobile: ThunkPaymentMobile,
    ReplenishmentMobile: ThunkReplenishmentMobile,
    ReportMobile: ThunkReportMobile,
    SecurityMobile: ThunkSecurityMobile,
    SupportMobile: ThunkSupportMobile,
    WithdrawalsMobile: ThunkWithdrawalsMobile
}